export const REA_METER_ALERT_DAYS = 18;
export const REA_METER_ALERT_TITLE = 'MOVE.CONTACT_LOGS.CUSTOM_MESSAGE.REAL_ESTATE_AGENT_METER_COLLECTION_ALERT.TITLE';
export const REA_METER_ALERT_CONTENT = 'MOVE.CONTACT_LOGS.CUSTOM_MESSAGE.REAL_ESTATE_AGENT_METER_COLLECTION_ALERT.CONTENT';
